// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","wrapper":"zAoo2","s4lwrapper":"wu2js","s4Lwrapper":"wu2js"};